import { render, staticRenderFns } from "./ListedOpinionItem.vue?vue&type=template&id=77bd1366&scoped=true&"
import script from "./ListedOpinionItem.vue?vue&type=script&lang=js&"
export * from "./ListedOpinionItem.vue?vue&type=script&lang=js&"
import style0 from "./ListedOpinionItem.vue?vue&type=style&index=0&id=77bd1366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bd1366",
  null
  
)

export default component.exports